import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

const commonButtonStyles = {
  margin: 0,
  boxShadow: 'none',
  borderRadius: 100,
  'text-transform': 'capitalize',
};
export const styles = makeStyles((theme: NextTheme) =>
  createStyles({
    submitButton: {
      background: Colors.medium_blue,
      color: Colors.white,
      boxShadow: 'none',
      margin: 0,
      '&:hover': {
        background: Colors.lightest_grey1,
      },
    },
    cancelButton: {
      background: Colors.light_blue,
      color: Colors.medium_blue,
      boxShadow: 'none',
      margin: 0,
      '&:hover': {
        background: Colors.lightest_grey1,
      },
    },
    dialogPaper: {
      overflowY: 'unset',
      minWidth: '400px',
    },
    dialogContent: {
      overflowY: 'unset',
      padding: `${theme.spacing(1)} ${theme.spacing(3)} !important`,
    },
    createButton: {
      ...commonButtonStyles,
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      background: Colors.navy,
      color: Colors.white,
      '&:hover': {
        background: Colors.navy,
      },
    },
    templateRadioGroup: {
      maxHeight: '500px',
      overflowY: 'auto',
      width: '100%',
      flexWrap: 'unset',
      WebkitFlexWrap: 'unset',
      marginBottom: '10px',
    },
    exportListbutton: {
      ...commonButtonStyles,
      paddingRight: theme.spacing(2.5),
      paddingLeft: theme.spacing(2.5),
      marginRight: theme.spacing(1.875),
      color: Colors.navy,
      border: `1px solid ${Colors.navy} !important`,
      backgroundColor: Colors.white,
      '&:hover': {
        backgroundColor: Colors.hover_gray,
      },
    },
  }),
);
